import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { ClientAuthProvider, useClientAuth } from "../../auth/ClientAuthProvider";
import { useClientPortalPaths } from "../../hooks/useClientPortalBase";

const ClientLogoutContent = () => {
  const { logout } = useClientAuth();
  const paths = useClientPortalPaths();

  useEffect(() => {
    logout();
  }, [logout]);

  return <Navigate to={paths.login} replace />;
};

const ClientLogoutPage = () => (
  <ClientAuthProvider>
    <ClientLogoutContent />
  </ClientAuthProvider>
);

export default ClientLogoutPage;
